import axios from 'axios'
import { Message, MessageBox } from 'element-ui'

// const mockConfig = require('../../../../config/mock.config')
// export const baseURL = mockConfig.hosts + mockConfig.prefix

// // 允许跨域传递Cookie
// axios.defaults.withCredentials = true
// // 请求超时时间
// axios.defaults.timeout = 10000
// 请求头 'Content-Type': 'application/json'
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencodedcharset=UTF-8'
const sessionId = localStorage.getItem('sessionId')
const usercode = localStorage.getItem('usercode')
const autorityText = `sessionId=${sessionId};usercode=${usercode}`
// 创建axios
const http = axios.create({
  // baseURL: baseURL,
  timeout: 60000,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Autority': autorityText
  }
})
// 请求拦截
http.interceptors.request.use(
  config => {
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应的拦截
http.interceptors.response.use(
  response => {
    const { data } = response
    if (data.statusCode === 100010) {
      Message.error('会话已过期, 请重新登录!')
      window.location.href = '#/qwLogin'
      return
    }
    // 不使用 !== 因为接口返回格式不同
    if (![200].includes(Number(data.statusCode || data.stateCode))) {
      Message.error(data.message || data.statusMessage || data.data || '系统内部错误')
      return Promise.reject({ ...data })
    } else {
      return data
    }
  },
  error => {
    if (error.response) {
      Message.error(`${error.response.status}：${error.response.statusText}`)
      switch (error.response.statusCode) {
        case 100010:
          MessageBox.alert('会话已过期, 请重新登录!', '提示', {
            confirmButtonText: '确定',
            type: 'warning',
            showClose: false,
            callback: () => {
              window.location.href = '#/qwLogin'
              window.close()
            }
          })
          break
      }
    } else {
      Message.error(`${error}`)
    }
    return Promise.reject(error.response)
  }
)

export default http



// WEBPACK FOOTER //
// ./src/pages/air-service/apis/index.js